(function() {
    var isPetDomain = window.location.hostname === 'pet.allnutrition.cl';
    if (isPetDomain) {
        var originalFetch = window.fetch;
        window.fetch = function(url, options) {
        if (typeof url === 'string' && url.includes('bc-sf-filter')) {
            var separator = url.includes('?') ? '&' : '?';
            url = url + separator + 'tag=allpets';
        }
        return originalFetch.call(this, url, options);
        };
        return;
    }

    var isMainDomain = window.location.hostname === 'allnutrition.cl';
    if (isMainDomain) {
        var originalFetch2 = window.fetch;
        window.fetch = function(url, options) {
        if (typeof url === 'string' && url.includes('bc-sf-filter')) {
            var separator = url.includes('?') ? '&' : '?';
            url = url + separator + 'h_options=allpets';
        }
        return originalFetch2.call(this, url, options);
        };
    }
})();